import { FC } from "react";

import { Box, Divider, Typography } from "@mui/material";
import { Toolbar } from "@mui/x-data-grid";

import { ExportFormat, ExportMenu } from "./ExportMenu";
import { TableToolbarSearch, TableToolbarSearchType } from "./TableToolbarSearch";

export type TableToolbarProps = {
  label?: string;
  onExport: (format: ExportFormat) => void;
  leftActions?: React.ReactNode[];
  withSearch?: TableToolbarSearchType;
};

export const TableToolbar: FC<TableToolbarProps> = ({ label = "", onExport, leftActions, withSearch }) => {
  return (
    <Toolbar>
      <Typography className="MuiDataGrid-columnHeaderTitle" fontWeight="bold">
        {label}
      </Typography>
      {!!label && leftActions && <Divider orientation="vertical" sx={{ mx: 1 }} flexItem />}
      {leftActions}
      <Box sx={{ flexGrow: 1 }} />
      {!!withSearch && <TableToolbarSearch {...withSearch} />}
      <ExportMenu onExport={onExport} inGridToolbar />
    </Toolbar>
  );
};
